import REGION from 'types/region';

const COUNTRIES_WITH_BANK_NUMBER = ['AU'];

const isBankNumberRequired = (region: 'au' | 'nz' | REGION): boolean =>
  COUNTRIES_WITH_BANK_NUMBER.includes(region.toUpperCase());

export default isBankNumberRequired;
